<template>
  <div class="index">
    <div class="gradient"></div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "WalletPaymentPage",
  data() {
    return {
      errorState: false,
      errorMsg: "",
      loading: true,
      apiKey: "",
      merchantPassword: "",
      shop: "",
      domain: "",
      config: {},
      session: {},
    };
  },
  methods: {
    async getData(shop, domain) {
      const config = await axios
        .get(`/wallet/configuration/get?shop=${shop || domain}`)
        .then((resp) => {
          // console.log("Config:", resp.data);
          return resp.data;
        })
        .catch((err) => {
          console.log("Error in getting Config:", err.response.data);
        });
      const session = await axios
        .get(`/wallet/session/get?shop=${shop || domain}`)
        .then((resp) => {
          // console.log("Session:", resp.data);
          return resp.data;
        })
        .catch((err) => {
          console.log("Error in getting Session:", err.response.data);
        });

      // const session = await window.session.getSessionByShop(shop || domain);
      this.config = config;
      this.session = session;
      return { config: config, session: session };
    },
  },
  async mounted() {
    const shop = this.$route.query.shop;
    const hmac = this.$route.query.hmac;
    if (hmac) {
      const fullUrl = window.location.href;
      try {
        const res = await axios.post("/wallet/api/validate-hmac", { fullUrl });
        console.log("Is valid HMAC?", res.data.isValid);
        if (res.data.isValid) {
          window.location.href = `/wallet/auth?shop=${shop}`;
        }
      } catch (err) {
        console.error("HMAC check failed", err);
      }
    }
  },
  beforeUnmount() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import url("https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");

#config_page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      max-height: 70px;
      aspect-ratio: auto;
    }
  }
}

#lll {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  .loader {
    margin-top: 2rem;
    width: 50px;
    aspect-ratio: 1;
    border-radius: 50%;
    border: 8px solid #155eef;
    animation: l20-1 0.8s infinite linear alternate, l20-2 1.6s infinite linear;
  }
}
@keyframes l20-1 {
  0% {
    clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%);
  }
  12.5% {
    clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 0%,
      100% 0%,
      100% 0%
    );
  }
  25% {
    clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 100%,
      100% 100%,
      100% 100%
    );
  }
  50% {
    clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }
  62.5% {
    clip-path: polygon(
      50% 50%,
      100% 0,
      100% 0%,
      100% 0%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }
  75% {
    clip-path: polygon(
      50% 50%,
      100% 100%,
      100% 100%,
      100% 100%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }
  100% {
    clip-path: polygon(
      50% 50%,
      50% 100%,
      50% 100%,
      50% 100%,
      50% 100%,
      50% 100%,
      0% 100%
    );
  }
}
@keyframes l20-2 {
  0% {
    transform: scaleY(1) rotate(0deg);
  }
  49.99% {
    transform: scaleY(1) rotate(135deg);
  }
  50% {
    transform: scaleY(-1) rotate(0deg);
  }
  100% {
    transform: scaleY(-1) rotate(-135deg);
  }
}

.index {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100vh;
  width: 100%;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #0f0c22;
  overflow: hidden;
}

.gradient {
  position: absolute;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    circle at center,
    #6ed7ca,
    rgba(255, 255, 255, 0)
  );
  animation: moveBlob 20s infinite;
  border-radius: 50%;
  filter: blur(100px);
}

@keyframes moveBlob {
  0% {
    transform: translate(-70%, -70%) scale(1);
  }
  25% {
    transform: translate(70%, -70%) scale(2);
  }
  50% {
    transform: translate(-70%, 70%) scale(1);
  }
  75% {
    transform: translate(70%, 70%) scale(2);
  }
  100% {
    transform: translate(-70%, -70%) scale(1);
  }
}
</style>
